<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';

import { useI18n } from 'vue-i18n';
const props = defineProps({
  inboxName: {
    type: String,
    default: '',
  },
  inboxIcon: {
    type: String,
    default: '',
  },
  scheduledAt: {
    type: Number,
    default: 0,
  },
});

const { t, locale } = useI18n();

// Owner order 2026-09-14 (campaign audit, option 5): the date follows the
// UI language (Gregorian, Latin digits) instead of a fixed English stamp.
const scheduledLabel = computed(() => {
  if (!props.scheduledAt) return '';
  const tag = String(locale.value).startsWith('ar')
    ? 'ar-u-ca-gregory-nu-latn'
    : 'en-US';
  return new Date(props.scheduledAt * 1000).toLocaleString(tag, {
    dateStyle: 'medium',
    timeStyle: 'short',
  });
});
</script>

<template>
  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.SENT_FROM') }}
  </span>
  <div class="flex items-center gap-1.5 flex-shrink-0">
    <Icon :icon="inboxIcon" class="flex-shrink-0 text-n-slate-12 size-3" />
    <span class="text-sm font-medium text-n-slate-12">
      {{ inboxName }}
    </span>
  </div>

  <span class="flex-shrink-0 text-sm text-n-slate-11 whitespace-nowrap">
    {{ t('CAMPAIGN.SMS.CARD.CAMPAIGN_DETAILS.ON') }}
  </span>
  <span class="flex-1 text-sm font-medium truncate text-n-slate-12">
    {{ scheduledLabel }}
  </span>
</template>
